import moment from 'moment';
import { isEqual } from 'lodash';
import { writeErr } from '../common/logger';
import { getParams } from '../common/utils';
import { reportTypes } from '../../store/repiStore';
import { hasPermission } from '../../store/apiWrapper';
import { isNullOrUndefined, isString } from '../../store/storeFunctions';

const REPI_CONSENTS_STORAGE = "repi_consents";
const AUTH_STORAGE = "auth";

export function getReportType() {
    const match =  window.location.pathname.match(/\/repi\/report\/(\w+)\/(\d+)/);
    if (isNullOrUndefined(match))
        return null;
    const reportType = match[1];
    return reportType;
}

export function getPoolGroup() {
    const params = getParams(window.location.search);
    return isNullOrUndefined(params) || isNullOrUndefined(params.poolGroup) ? null : parseInt(params.poolGroup);
}

export function isPoolReport(reportType) {
    return [reportTypes.poolPlus, reportTypes.poolMinus].reduce((a, c) => reportType.toLowerCase() === c.toLowerCase() || a, false);
}

export function isPlusReport(reportType) {
    return [reportTypes.creditPlus, reportTypes.poolPlus].reduce((a, c) => reportType.toLowerCase() === c.toLowerCase() || a, false);
}

export function isInvoicesReport(reportType, plusOnly) {
    const reports = plusOnly ? [reportTypes.invoicesPlus] : [reportTypes.invoicesMinus, reportTypes.invoicesPlus];
    return reports.reduce((a, c) => reportType.toLowerCase() === c.toLowerCase() || a, false);
}

export function isValidDate(date) {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}

export function formatNumber(value, locale, defaultValue = undefined) {
    if (isNullOrUndefined(value))
        return null;

    defaultValue =  defaultValue === undefined ? value : defaultValue;

    value = Math.round(value);
    if (isNaN(value))
        value = defaultValue;

    if (isNullOrUndefined(locale))
        return defaultValue === undefined ? value : defaultValue;

    try {
        return Intl.NumberFormat(locale).format(value);
    } catch (e) {
        writeErr(e);
        return defaultValue;
    }
}

export function hasConsentInStorage(subjectId) {
    const key = isString(subjectId) ? subjectId : isNullOrUndefined(subjectId) ? "" : subjectId.toString();
    const repiConsents = localStorage.getItem(REPI_CONSENTS_STORAGE);

    if (!isNullOrUndefined(repiConsents)) {
        const consents = JSON.parse(repiConsents);
        if (!isNullOrUndefined(consents[key])) {
            const maxVal = moment(consents[key]).add(1, 'days').toDate();
            return maxVal > new Date();
        }
    }

    return false;
}

export function addConsentToStorage(subjectId) {
    const key = isString(subjectId) ? subjectId : isNullOrUndefined(subjectId) ? "" : subjectId.toString();
    const repiConsents = localStorage.getItem(REPI_CONSENTS_STORAGE);

    if (!isNullOrUndefined(repiConsents)) {
        const consents = JSON.parse(repiConsents);
        consents[key] = new Date();
        localStorage.setItem(REPI_CONSENTS_STORAGE, JSON.stringify(consents))
    } else
        localStorage.setItem(REPI_CONSENTS_STORAGE, JSON.stringify({ [key]: new Date() }));
}

export function getReportsAvailability() {
    const auth = { authentication: JSON.parse(localStorage.getItem(AUTH_STORAGE)) };
    if (isNullOrUndefined(auth.authentication))
        return null;

    const negativeOnly = auth.authentication.repi.negativeDataOnly;
    const hasGroups = Object.keys(auth.authentication.repi.customerGroups || {}).length > 0;
    const isSk = auth.authentication.profile.agentLanguage === "sk-SK";

    return {
        creditMinus: hasPermission(auth, isSk ? "REPISkCreditReportMinus" : "REPICreditReportMinus"),
        creditPlus: !negativeOnly && hasPermission(auth, isSk ? "REPISkCreditReportPlus" : "REPICreditReportPlus"),
        subjectPlus: !negativeOnly && hasPermission(auth, isSk ? "REPISkCreditReportPlusSubject" : "REPICreditReportPlusSubject"),
        poolMinus: hasGroups && hasPermission(auth, isSk ? "REPISkCreditReportPoolMinus" : "REPICreditReportPoolMinus"),
        poolPlus: !negativeOnly && hasGroups && hasPermission(auth, isSk ? "REPISkCreditReportPoolPlus" : "REPICreditReportPoolPlus"),
        invoicesMinus: hasPermission(auth, isSk ? "REPISkCreditReportInvoicesMinus" : "REPICreditReportInvoicesMinus"),
        invoicesPlus: !negativeOnly && hasPermission(auth, isSk ? "REPISkCreditReportInvoicesPlus" : "REPICreditReportInvoicesPlus"),
        dataCorrectionContributor: hasPermission(auth, "REPIDataCorrectionContributor"),
        dataCorrectionInternal: hasPermission(auth, "REPIDataCorrectionInternal")
    };
}

export function emToPx(em) {
    return isNullOrUndefined(em) ? 0 : em * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export function reportUrlChanged(prevProps, nextProps) {
    if (isNullOrUndefined(prevProps) || isNullOrUndefined(nextProps) || !isString(prevProps.location) || !isString(nextProps.location))
        return false;

    const prev = prevProps.location.split("?");
    const next = nextProps.location.split("?");
    if (prev.length != next.length || prev[0] != next[0])
        return true;

    const prevQuery = prev.length === 2 ? getParams(prev[1]) : {};
    const nextQuery = next.length === 2 ? getParams(next[1]) : {};
    return !isEqual(prevQuery, nextQuery);
}

export function repiDomainNotInitilized(domain, key) {
    return (isNullOrUndefined(domain) || isNullOrUndefined(domain[key])
        || isNullOrUndefined(domain[key].requestResult)
        || domain[key].isRequesting === true
        || !Array.isArray(domain[key].requestResult))
}
